export default __webpack_public_path__ + "static/media/bg.837b9a41.png";